type ParrotEmblemProps = {
  className?: string;
  title?: string;
  animated?: boolean;
};

export default function ParrotEmblem({
  className = 'h-10 w-10',
  title = 'BirdMan Parrot Emblem',
  animated = true,
}: ParrotEmblemProps) {
  return (
    <svg
      viewBox="0 0 128 128"
      className={className}
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="bm-parrot-bg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#06b6d4" />
          <stop offset="55%" stopColor="#2563eb" />
          <stop offset="100%" stopColor="#7c3aed" />
        </linearGradient>
        <linearGradient id="bm-parrot-body" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#34d399" />
          <stop offset="100%" stopColor="#0ea5a4" />
        </linearGradient>
        <linearGradient id="bm-parrot-wing" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#22d3ee" />
          <stop offset="100%" stopColor="#6366f1" />
        </linearGradient>
      </defs>

      <circle cx="64" cy="64" r="60" fill="url(#bm-parrot-bg)" opacity="0.18" />
      <circle cx="64" cy="64" r="54" fill="white" opacity="0.92" />

      <g transform="translate(17 16)">
        <path
          d="M17 80 C12 66, 18 49, 31 39 C43 30, 60 26, 72 32 C84 38, 90 53, 87 68 C85 81, 74 92, 59 94 C43 97, 24 93, 17 80 Z"
          fill="url(#bm-parrot-body)"
        />
        <path
          d="M51 27 C56 18, 65 14, 72 16 C78 19, 82 25, 82 32 C82 42, 73 50, 62 50 C51 50, 44 42, 44 34 C44 31, 46 28, 51 27 Z"
          fill="#10b981"
        />
        <path
          d="M67 33 C75 27, 83 26, 89 31 C84 38, 75 43, 65 44 Z"
          fill="#f97316"
        />
        <circle cx="63.5" cy="33" r="3.8" fill="#0f172a" />
        <circle cx="62.5" cy="32" r="1.2" fill="white" />

        <path
          d="M32 59 C39 46, 56 39, 71 42 C62 54, 47 63, 31 66 Z"
          fill="url(#bm-parrot-wing)"
          opacity="0.95"
        >
          {animated ? (
            <animateTransform
              attributeName="transform"
              type="rotate"
              values="0 54 54; -6 54 54; 0 54 54"
              dur="4s"
              repeatCount="indefinite"
            />
          ) : null}
        </path>

        <path d="M23 76 C32 84, 46 89, 58 87 C48 95, 35 98, 24 95 Z" fill="#0f766e" opacity="0.95" />
        <path d="M57 86 C64 86, 70 82, 74 76 C73 89, 66 95, 56 95 Z" fill="#14b8a6" />
      </g>

      <g opacity="0.8">
        <path d="M20 37 C28 31, 34 30, 40 34" stroke="#06b6d4" strokeWidth="3" strokeLinecap="round">
          {animated ? (
            <animate attributeName="opacity" values="0.4;1;0.4" dur="3.5s" repeatCount="indefinite" />
          ) : null}
        </path>
        <path d="M90 92 C98 86, 104 84, 110 88" stroke="#8b5cf6" strokeWidth="3" strokeLinecap="round">
          {animated ? (
            <animate attributeName="opacity" values="0.4;1;0.4" dur="3.2s" repeatCount="indefinite" />
          ) : null}
        </path>
      </g>
    </svg>
  );
}

